import { useContext } from "react";
import star from "../images/star.png";
import uprightarrow from "../images/uprightarrow.png";
import { SectionsContext } from "../store/section-context";

function Reviews() {
  const { reviews } = useContext(SectionsContext);
  return (
    <div className="homeSegment6  p-md-5 p-4">
      <div className="d-flex">
        <div className="homeSegment1aboutusline"></div>
        <div className="homeSegment1aboutus ps-2">{reviews.heading} </div>
      </div>
      <div className="d-flex homeSegment6container">
        <div className="homeSegment3intro py-3">{reviews.intro}</div>

        <div className="pt-2 pt-md-5">
          <a
            href="https://www.homecare.co.uk/homecare/agency.cfm/id/65432245376#reviews"
            className="testimonialbtn"
          >
            <span className="pe-2">View All Testimonials</span>{" "}
            <img
              src={uprightarrow}
              alt="arrow"
              className="homeSegment6testimoialarrow"
            />
          </a>
        </div>
      </div>

      <div className="testimonials pt-3">
        {reviews.items.map(({ title, body, author, stars }, index) => {
          const starsNo = isNaN(Number(stars)) ? Number(stars) : 4;

          return (
            <div className="testimonial" key={index}>
              <div className="testimonialrating">
                {Array(starsNo)
                  .fill()
                  .map((_, index) => (
                    <img key={index} src={star} alt="star" />
                  ))}
              </div>
              <div className="testimonialtitle pt-4">{title}</div>
              <div className="testimonialparagraph pt-3">{body}</div>
              <div className="testimonialperson pt-4 d-flex">
                <div></div>
                <div className="pt-3">
                  <div className="testimonialname"> {author} </div>
                  {/* <div className="testimonialplace">USA, California</div> */}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Reviews;
